import type { SchemaBuilderConditionsProps } from "./schema-builder-condition.type";
import type { FormListFieldData } from "antd";

import { useTranslation } from "react-i18next";

import { SchemaBuilderFormList } from "../schema-builder-form-list";

import { SchemaBuilderConditionRow } from "./schema-builder-condition-row";
import { getConditionFieldPath } from "./schema-builder-condition.helper";

import "./schema-builder-condition.style.less";

export const SchemaBuilderConditions = ({
  name,
  parentName,
  initialValues,
}: SchemaBuilderConditionsProps) => {
  const { t } = useTranslation();

  const getFieldPath = (field: FormListFieldData) => {
    return getConditionFieldPath({ field, formListName: name, parentName });
  };

  return (
    <SchemaBuilderFormList
      name={name}
      title={t("schema:conditions.title")}
      tooltip={t("schema:conditions.tooltip")}
      addText={t("schema:conditions.add")}
      className="schema-builder-conditions"
      renderField={(field, { index, removeField }) => (
        <SchemaBuilderConditionRow
          key={`condition-row-${field.key}`}
          field={field}
          index={index}
          fieldPath={getFieldPath(field)}
          initialValues={initialValues?.[field.name]}
          onDeleteClick={() => removeField(field.name)}
        />
      )}
    />
  );
};
